import { useParams } from "react-router-dom";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import { roadInfoCardStructure } from "./structure";
import { ButtonsOptions, CardInfoSection } from "../../../widgets/cards/CardInfoSection";
import { useEffect, useState } from "react";
import { useRoadInfoCardData } from "./hooks/useRoadInfoCardData";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { PathNormativitiesTabView } from "./pathNormativitiesTabView";

const initButtonsOptions: ButtonsOptions = {
    documents: {
        isLoading: true
    }
}

export function RoadInfoCard() {
    const cardStructure = roadInfoCardStructure
    const { roadId } = useParams<{ roadId: string }>();
    const [cardName, setCardName] = useState<string>('')
    const [buttonsOptions, setButtonsOptions] = useState<ButtonsOptions | null>(initButtonsOptions);
    const roadPaths = getItemWebStorage('pathsInfo')?.pathsList?.filter((path: any) => path?.RoadId == roadId) ?? []

    const { data, isLoadingMainData, documents } = useRoadInfoCardData(roadId) ?? {}

    useEffect(() => {
        if (data?.Name) {
            setCardName(`Дорога ${data.Name}`);
        }
    }, [data]);

    useEffect(() => {
        if (documents) {
            const numberOfDocuments = documents?.value.length
            const disabled = numberOfDocuments === 0

            const buttonsOptions: ButtonsOptions = {
                documents: {
                    numberOfDocuments,
                    disabled,
                    isLoading: false
                }
            }
            setButtonsOptions(buttonsOptions)
        }
    }, [documents])

    return (
        <>
            <ContentHeader title={cardName} />
            <div className="card-div road-info-card-div">
                {cardStructure.map((sectionOptions: any) =>
                    <CardInfoSection
                        sectionOptions={sectionOptions}
                        data={data}
                        isLoadingMainData={isLoadingMainData}
                        buttonsOptions={buttonsOptions}
                    />
                )}
                <PathNormativitiesTabView paths={roadPaths} />
            </div>
        </>
    )
}
